exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top[data-v-5e276e83]{height:300px}.top .el-divider--horizontal[data-v-5e276e83]{margin:20px 0}.right[data-v-5e276e83]{width:345px;margin-left:20px;padding:20px;border:1px solid #e6e6e6}.right p[data-v-5e276e83]{line-height:32px}.right span[data-v-5e276e83]{font-size:16px}.right .el-tag[data-v-5e276e83]{color:#ff8500;margin-top:10px;font-size:14px}.record_header[data-v-5e276e83]{padding-left:15px;border-left:3px solid #2993ff;margin:20px 0}\n", ""]);

// exports
